import React, { Fragment, memo } from "react";
import Button from "../button/Button";
import { useTranslate } from "../../translate";
import { useBreakpointsContext } from "../../hooks";
import { PROXY, termsLink } from "../../constants";

async function trackDownloadingOnXHR(url, fileName) {
    return new Promise(resolve => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = "blob";
        xhr.open("GET", `${PROXY}/${url}`);
        xhr.setRequestHeader("origin", window.location.origin);
        xhr.onreadystatechange = event => {
            if (xhr.readyState === 2 && xhr.status === 200) {
                // Download is being started
            } else if (xhr.readyState === 3) {
                // Download is under progress
            } else if (xhr.readyState === 4) {
                // Downloaing has finished
                const objectUrl = URL.createObjectURL(xhr.response);
                const link = document.createElement("a");
                link.href = objectUrl;
                link.download = fileName;
                link.click();
                setTimeout(() => {
                    window.URL.revokeObjectURL(objectUrl);
                    link.remove();
                    resolve();
                }, 0);
            }
        };
        xhr.send();
    });
}

function ItineraryFooter(props) {
    const { style, itineraryMetadata, className, showToast, setIsEmailModalVisible } = props;
    const { isMobile } = useBreakpointsContext();
    const translate = useTranslate();
    const gpxUrl = itineraryMetadata.GPXDownload;

    const downloadGPX = async () => {
        const fileName = gpxUrl.substring(gpxUrl.lastIndexOf("/") + 1);
        await trackDownloadingOnXHR(gpxUrl, fileName);
        showToast({ toastProps: { message: "GPX downloaded!" } });
    };
    const onEmailBtnClick = async () => {
        setIsEmailModalVisible(true);
    };

    return (
        <footer className={`trpr__itinerary-footer ${gpxUrl ? "with-gpx-url" : ""} ${className}`} style={style}>
            {gpxUrl && (
                <Fragment>
                    <p className="trpr__itinerary-footer-intro trpr__hide-in-pdf-mode">
                        Take advantage of these offline resources to help you further plan your trip.
                    </p>
                    <div className="trpr__itinerary-footer-buttons trpr__hide-in-pdf-mode">
                        <Button
                            text={translate("Email to myself")}
                            type="white"
                            icon="email"
                            size="md"
                            expand={isMobile}
                            onClick={onEmailBtnClick}
                        />
                        <Button
                            disabled={!gpxUrl}
                            text={translate("Download GPX")}
                            type="white"
                            icon="gpx"
                            size="md"
                            expand={isMobile}
                            onClick={downloadGPX}
                        />
                    </div>
                </Fragment>
            )}
            <p className="trpr__itinerary-footer-copy">
                {/*Veuillez noter que des efforts sont consacrés à la mise à jour de ces parcours à jour, il n'est pas possible de garantir l'exactitude de tous les renseignements fournis. En employany cet outil, vous en acceptez les terms and conditions.*/}
                Please note that while we endeavour to keep these itineraries up-to-date we cannot guarantee the
                reliability of all information. By using this website you agree to our{" "}
                <a href={termsLink} target="_blank" rel="noopener noreferrer">
                    terms and conditions
                </a>
                .
            </p>
        </footer>
    );
}

export default memo(ItineraryFooter);
